// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__j4P0S","author":"Table_author__m0ggW","authorImage":"Table_authorImage__1_2dT","unreadRow":"Table_unreadRow__4MYrB"};